<template>
    <main>
        <div class="honor">
            <div v-if="honorList.length > 0">
                <div class="content">
                    <div style="margin:0 auto;">
                        <img :src="honorImg" class="honorImg">
                    </div>
                    <div class="honorList">
                        <div class="list-contain">
                            <div class="time">
                                <div v-for="(item, index) in honorList" :class="{ active: index == current }">{{ Object.keys(item)[0] }}<span></span><span></span><span></span></div>
                            </div>
                        </div>

                        <div class="honorDetial" @scroll="scrollEvent">
                            <div class="item" v-for="(item, index) in honorList">
                                <div v-for="(sitem, index1) in item[Object.keys(item)[0]]" :class="{ active: index == listx && index1 == listy }" @click="getCur(index, index1, sitem)">
                                    {{ sitem.year }}{{ sitem.orgName }}{{ sitem.honorName }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="empty">
                暂无数据
            </div>
        </div>
    </main>
</template>
<style lang="less" scoped>
@red: #e60012;

.honor {
    width: 1200px;
    margin: 0 auto;

    .content {
        width: 1200px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 13px;

        img {
            max-width: 470px;
            max-height: 441px;
            object-fit: cover;
        }

        ;

        .honorList {
            display: flex;

            .list-contain {
                width: 38px;
                overflow: hidden;
            }

            .time {
                height: 441px;
                width: 48px;
                overflow: auto;

                &::-webkit-scrollbar {
                    display: none;
                }

                div {
                    color: #888888;
                    font-size: 14px;
                    line-height: 30px;
                    font-weight: 400;
                    position: relative;

                    &.active {
                        color: @red;
                        font-weight: bold;
                    }

                    &:not(:last-child) {
                        span {
                            display: none;
                            background-color: #D2D2D2;
                            width: 6px;
                            height: 14px;
                            margin-bottom: 10px;
                            position: relative;
                            left: 16px;

                            &:first-child {
                                height: 24px;
                            }

                            &:last-child {
                                height: 10px;
                                margin-bottom: 0;
                                display: block;
                            }
                        }

                        &.active {
                            span {
                                display: block;
                            }
                        }

                    }
                }
            }

            .honorDetial {
                height: 441px;
                overflow: auto;
                border-left: 1px solid #D2D2D2;
                padding-left: 21px;
                margin-left: 27px;
                font-size: 14px;
                line-height: 24px;

                .item {
                    div {
                        padding: 0 9px;
                        width: 450px;
                        text-align: left;
                        cursor: pointer;

                        &.active {
                            background-color: @red;
                            color: #FFFFFF;
                        }
                    }
                }

            }
        }
    }

    .empty {
        color: #888;
        height: 151px;
        line-height: 151px;
    }
}

@media screen and (max-width: 1360px) {
    .honor {
        width: 100%;

        .content {
            display: flex;
            flex-direction: column;
            width: 100%;

            img {
                width: 100%;
                height: auto;
                max-width: unset;
            }
        }

        .honorList {
            width: 100%;
            padding: 15px;

            .honorDetial {
                flex: 1;

                .item {
                    div {
                        padding: 5px 10px !important;
                        width: auto !important;
                    }
                }
            }
        }
    }
}
</style>
<script>
export default {
    data() {
        return {
            listx: 0,
            listy: 0,
            honorList: [],
            honorImg: '',
            toggeleSrc: true,
            current: 0,
        }
    },
    computed: {
        id() {
            return this.$route.params.id
        }
    },
    methods: {
        getCur(x, y, item) {
            // this.honorImg = item.profuctPicture
            let that = this;
            if (that.listx == x && that.listy == y || !that.toggeleSrc) return;
            that.toggeleSrc = false;
            that.listx = x;
            that.current = x;
            that.listy = y;
            $(".honorImg").animate(
                { opacity: 'toggle' },
                "normal",
                null,
                function () {
                    $(".honorImg").attr("src", item.profuctPicture);
                    $(".honorImg").animate({ opacity: 'toggle' }, "normal");
                    setTimeout(() => {
                        that.toggeleSrc = true
                    }, 300)
                }
            );
        },
        scrollEvent() {
            let currentHeight = 0, nextHeight = $('.honorDetial .item')[0].offsetHeight;
            for (let i = 0; i < $('.honorDetial .item').length; i++) {
                if ($('.honorDetial')[0].scrollTop > currentHeight && $('.honorDetial')[0].scrollTop < nextHeight) {
                    this.current = i;
                }
                currentHeight = currentHeight + $('.honorDetial .item')[i].offsetHeight;
                if ($('.honorDetial .item')[i + 1]) {
                    nextHeight = nextHeight + $('.honorDetial .item')[i + 1].offsetHeight;
                }
            }
        },
        getHonor() {
            var that = this;
            ajax.call(this, {
                url: "/bloc/honorInfo/list/language",
                data: {
                    companyId: that.id
                },
                s(res) {
                    if (res.data.length > 0) {
                        that.honorList = res.data;
                        let current = res.data[0]
                        that.honorImg = current[Object.keys(current)[0]][0].profuctPicture
                    }
                }
            });
        }

    },
    mounted() {
        this.getHonor();
    },
    watch: {
        "$root.language"() {
            this.getHonor();
        },
        id() {
            this.getHonor();
        }

    }
}
</script>